import { createApolloClient } from "../apollo";
import { DEVELOPMENT_MODE, WINDOW_EXISTS } from "../constants";
import { auth } from "./auth";
import { getState, type State } from "./state";
import { createStorage, storage } from "./storage";
import { type SaleorClient, type SaleorClientOpts } from "./types";
import { user } from "./user";

export const createSaleorClient = ({
  apiUrl,
  channel,
  audience,
  opts = {},
}: SaleorClientOpts): SaleorClient => {
  let _channel = channel;
  const { autologin = true, fetchOpts } = opts;

  const setChannel = (channel: string): string => {
    _channel = channel;

    return _channel;
  };

  createStorage(autologin, audience);

  const apolloClient = createApolloClient(apiUrl, autologin, fetchOpts);
  const authSDK = auth({ apolloClient });
  const userSDK = user({ apolloClient, channel: _channel });

  // Silent re-auth on load: if a CSRF token was persisted from a prior login,
  // exchange the httpOnly refresh-token cookie it pairs with for a fresh access
  // token. The refresh token itself is never in JS storage anymore. (External/SSO
  // refresh isn't used by this portal, so the internal cookie flow is sufficient.)
  const csrfToken = storage.getCSRFToken();

  if (autologin && csrfToken) {
    authSDK.refreshToken(true);
  }

  const client = {
    auth: authSDK,
    user: userSDK,
    config: { channel: _channel, setChannel, autologin },
    _internal: { apolloClient },
    getState: (): State => getState(apolloClient),
  };

  if (DEVELOPMENT_MODE && WINDOW_EXISTS) {
    (window as any).__SALEOR_CLIENT__ = client;
  }

  return client;
};
